export const AUTH_TOKEN_CACHE_KEY = 'CR_AUTH_TOKEN';

export const AUTH_REFRESH_TOKEN_CACHE_KEY = 'CR_AUTH_REFRESH_TOKEN';
